// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== MAIN CONTAINER ==================== */

.lb-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 400px;
  display: grid;
  gap: 0.75rem;
  padding: 0.5rem;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 12px;
  overflow: hidden;
}

/* ==================== DYNAMIC GRID LAYOUTS ==================== */

.lb-grid-2 {
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
}

.lb-grid-3 {
  grid-template-columns: 2fr 1fr;
  grid-template-rows: repeat(2, 1fr);
}

.lb-grid-3 .lb-grid-item:first-child {
  grid-row: 1 / 3;
}

.lb-grid-4 {
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

.lb-grid-6 {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

.lb-grid-6 .lb-grid-item:first-child {
  grid-column: 1 / 3;
  grid-row: 1 / 3;
}

.lb-grid-many {
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  grid-auto-rows: minmax(150px, 200px);
  max-height: 500px;
  overflow-y: auto;
}

/* ==================== GRID ITEMS ==================== */

.lb-grid-item {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 150px;
  overflow: hidden;
  border-radius: 8px;
}

/* ==================== MEDIA ITEMS (GRAYED OUT BY DEFAULT) ==================== */

.lb-media-item {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 8px;
  /* ✅ INITIAL STATE: GRAYED OUT */
  filter: grayscale(100%) brightness(0.7);
  opacity: 0.8;
}

/* ✅ ON HOVER: SHOW NATURAL COLORS */
.lb-media-item:hover {
  filter: grayscale(0%) brightness(1);
  opacity: 1;
  transform: scale(1.05);
  z-index: 2;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

/* ✅ CONTAINER HOVER: DIM OTHER IMAGES */
.lb-container:hover .lb-media-item:not(:hover) {
  filter: grayscale(100%) brightness(0.4);
  opacity: 0.6;
  transform: scale(0.95);
}

/* Focused State */
.lb-media-item.lb-focused {
  filter: grayscale(0%) brightness(1);
  opacity: 1;
  transform: scale(1.1);
  z-index: 10;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
}

/* ==================== VIDEO WRAPPER ==================== */

.lb-video-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
}

.lb-video-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lb-video-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #000;
  pointer-events: none;
  transition: all 0.3s ease;
}

.lb-video-wrapper:hover .lb-video-play-icon {
  background: rgba(255, 255, 255, 1);
  transform: translate(-50%, -50%) scale(1.1);
}

/* ==================== AUDIO WRAPPER ==================== */

.lb-audio-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 1rem;
}

.lb-audio-icon {
  font-size: 4rem;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.lb-audio-label {
  font-size: 1rem;
  font-weight: bold;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

/* ==================== SINGLE MEDIA ==================== */

.lb-single-media {
  width: 100%;
  height: 100%;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 12px;
  overflow: hidden;
}

.lb-single-media .lb-media-item {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  /* ✅ SINGLE IMAGE ALSO STARTS GRAYED OUT */
  filter: grayscale(100%) brightness(0.7);
}

.lb-single-media .lb-media-item:hover {
  filter: grayscale(0%) brightness(1);
}

/* ==================== DETAIL POPUP OVERLAY ==================== */

.lb-detail-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.lb-detail-modal {
  position: relative;
  display: flex;
  width: 90vw;
  max-width: 1200px;
  height: 85vh;
  max-height: 800px;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.5);
}

.lb-detail-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.3s ease;
}

.lb-detail-close:hover {
  background: rgba(0, 0, 0, 0.9);
  transform: scale(1.1);
}

/* ==================== DETAIL MEDIA (LEFT SIDE) ==================== */

.lb-detail-media {
  flex: 1.5 1;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.lb-detail-media-content {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.lb-detail-audio-wrapper {
  width: 80%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
}

.lb-detail-audio-wrapper audio {
  width: 100%;
}

/* ==================== DETAIL SIDEBAR (RIGHT SIDE) ==================== */

.lb-detail-sidebar {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: white;
  max-width: 400px;
}

/* Header */
.lb-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #e0e0e0;
}

.lb-detail-user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.lb-detail-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.lb-detail-user-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.lb-detail-username {
  font-weight: 600;
  font-size: 0.9rem;
}

.lb-detail-location {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  color: #666;
}

.lb-detail-menu {
  background: none;
  border: none;
  cursor: pointer;
  color: #333;
  padding: 0.5rem;
}

.lb-detail-menu:hover {
  color: #000;
}

/* Description */
.lb-detail-description {
  padding: 1rem;
  border-bottom: 1px solid #e0e0e0;
  font-size: 0.9rem;
  line-height: 1.5;
}

.lb-detail-desc-username {
  font-weight: 600;
  margin-right: 0.5rem;
}

.lb-detail-desc-text {
  color: #333;
}

/* Comments Section */
.lb-detail-comments {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem;
  border-bottom: 1px solid #e0e0e0;
}

.lb-detail-comment {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.lb-detail-comment-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.lb-detail-comment-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.lb-detail-comment-text {
  font-size: 0.85rem;
  line-height: 1.4;
}

.lb-detail-comment-username {
  font-weight: 600;
  margin-right: 0.5rem;
}

.lb-detail-comment-meta {
  display: flex;
  gap: 1rem;
  font-size: 0.75rem;
  color: #999;
}

.lb-detail-comment-meta button {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 0;
  font-size: 0.75rem;
  font-weight: 600;
}

.lb-detail-comment-meta button:hover {
  color: #666;
}

.lb-detail-comment-like {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  padding: 0;
}

.lb-detail-comment-like:hover {
  color: #e74c3c;
}

.lb-detail-no-comments {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 2rem;
  text-align: center;
  color: #999;
}

.lb-detail-no-comments svg {
  opacity: 0.3;
}

.lb-detail-no-comments p {
  font-weight: 600;
  font-size: 1rem;
  color: #333;
  margin: 0;
}

.lb-detail-no-comments span {
  font-size: 0.85rem;
}

/* Footer */
.lb-detail-footer {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  border-top: 1px solid #e0e0e0;
}

.lb-detail-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lb-detail-actions-left {
  display: flex;
  gap: 1rem;
}

.lb-detail-action-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #333;
  padding: 0;
  transition: all 0.2s ease;
}

.lb-detail-action-btn:hover {
  color: #000;
  transform: scale(1.1);
}

.lb-detail-stats {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
}

.lb-detail-likes {
  font-weight: 600;
}

.lb-detail-time {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #999;
  font-size: 0.75rem;
}

.lb-detail-suggests {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  text-align: center;
}

.lb-detail-comment-form {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border: 1px solid #e0e0e0;
  border-radius: 24px;
}

.lb-detail-comment-input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 0.9rem;
  padding: 0.5rem;
}

.lb-detail-comment-submit {
  background: none;
  border: none;
  color: #0095f6;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.lb-detail-comment-submit:disabled {
  color: #b3d4ff;
  cursor: not-allowed;
}

.lb-detail-comment-submit:not(:disabled):hover {
  transform: scale(1.1);
}

/* ==================== RESPONSIVE ==================== */

@media (max-width: 768px) {
  .lb-detail-modal {
    flex-direction: column;
    width: 95vw;
    height: 90vh;
  }

  .lb-detail-media {
    flex: 1 1;
    max-height: 50%;
  }

  .lb-detail-sidebar {
    flex: 1 1;
    max-width: 100%;
  }

  .lb-container {
    min-height: 300px;
    gap: 0.5rem;
  }

  .lb-grid-2,
  .lb-grid-3,
  .lb-grid-4,
  .lb-grid-6 {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }

  .lb-grid-3 .lb-grid-item:first-child,
  .lb-grid-6 .lb-grid-item:first-child {
    grid-column: 1;
    grid-row: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/LightBox/lightBox.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mEAAmE;;AAEnE;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4DAA4D;EAC5D,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,yDAAyD;;AAEzD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kFAAkF;;AAElF;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iDAAiD;EACjD,kBAAkB;EAClB,gCAAgC;EAChC,uCAAuC;EACvC,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,mCAAmC;EACnC,UAAU;EACV,sBAAsB;EACtB,UAAU;EACV,yCAAyC;AAC3C;;AAEA,wCAAwC;AACxC;EACE,uCAAuC;EACvC,YAAY;EACZ,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,mCAAmC;EACnC,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,0CAA0C;AAC5C;;AAEA,4DAA4D;;AAE5D;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2DAA2D;;AAE3D;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,mEAAmE;;AAEnE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,uEAAuE;;AAEvE;EACE,WAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,0EAA0E;;AAE1E;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yDAAyD;;AAEzD;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAO;IACP,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;;;;IAIE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;;IAEE,cAAc;IACd,cAAc;EAChB;AACF","sourcesContent":["/* ==================== MAIN CONTAINER ==================== */\n\n.lb-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 400px;\n  display: grid;\n  gap: 0.75rem;\n  padding: 0.5rem;\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n/* ==================== DYNAMIC GRID LAYOUTS ==================== */\n\n.lb-grid-2 {\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: 1fr;\n}\n\n.lb-grid-3 {\n  grid-template-columns: 2fr 1fr;\n  grid-template-rows: repeat(2, 1fr);\n}\n\n.lb-grid-3 .lb-grid-item:first-child {\n  grid-row: 1 / 3;\n}\n\n.lb-grid-4 {\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n}\n\n.lb-grid-6 {\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n}\n\n.lb-grid-6 .lb-grid-item:first-child {\n  grid-column: 1 / 3;\n  grid-row: 1 / 3;\n}\n\n.lb-grid-many {\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  grid-auto-rows: minmax(150px, 200px);\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n/* ==================== GRID ITEMS ==================== */\n\n.lb-grid-item {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 150px;\n  overflow: hidden;\n  border-radius: 8px;\n}\n\n/* ==================== MEDIA ITEMS (GRAYED OUT BY DEFAULT) ==================== */\n\n.lb-media-item {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 8px;\n  /* ✅ INITIAL STATE: GRAYED OUT */\n  filter: grayscale(100%) brightness(0.7);\n  opacity: 0.8;\n}\n\n/* ✅ ON HOVER: SHOW NATURAL COLORS */\n.lb-media-item:hover {\n  filter: grayscale(0%) brightness(1);\n  opacity: 1;\n  transform: scale(1.05);\n  z-index: 2;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n}\n\n/* ✅ CONTAINER HOVER: DIM OTHER IMAGES */\n.lb-container:hover .lb-media-item:not(:hover) {\n  filter: grayscale(100%) brightness(0.4);\n  opacity: 0.6;\n  transform: scale(0.95);\n}\n\n/* Focused State */\n.lb-media-item.lb-focused {\n  filter: grayscale(0%) brightness(1);\n  opacity: 1;\n  transform: scale(1.1);\n  z-index: 10;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);\n}\n\n/* ==================== VIDEO WRAPPER ==================== */\n\n.lb-video-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.7);\n}\n\n.lb-video-thumbnail {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.lb-video-play-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 60px;\n  height: 60px;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  color: #000;\n  pointer-events: none;\n  transition: all 0.3s ease;\n}\n\n.lb-video-wrapper:hover .lb-video-play-icon {\n  background: rgba(255, 255, 255, 1);\n  transform: translate(-50%, -50%) scale(1.1);\n}\n\n/* ==================== AUDIO WRAPPER ==================== */\n\n.lb-audio-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 1rem;\n}\n\n.lb-audio-icon {\n  font-size: 4rem;\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n}\n\n.lb-audio-label {\n  font-size: 1rem;\n  font-weight: bold;\n  color: white;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n}\n\n/* ==================== SINGLE MEDIA ==================== */\n\n.lb-single-media {\n  width: 100%;\n  height: 100%;\n  min-height: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.lb-single-media .lb-media-item {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  /* ✅ SINGLE IMAGE ALSO STARTS GRAYED OUT */\n  filter: grayscale(100%) brightness(0.7);\n}\n\n.lb-single-media .lb-media-item:hover {\n  filter: grayscale(0%) brightness(1);\n}\n\n/* ==================== DETAIL POPUP OVERLAY ==================== */\n\n.lb-detail-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.lb-detail-modal {\n  position: relative;\n  display: flex;\n  width: 90vw;\n  max-width: 1200px;\n  height: 85vh;\n  max-height: 800px;\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 0 60px rgba(0, 0, 0, 0.5);\n}\n\n.lb-detail-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 40px;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.7);\n  border: none;\n  border-radius: 50%;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  transition: all 0.3s ease;\n}\n\n.lb-detail-close:hover {\n  background: rgba(0, 0, 0, 0.9);\n  transform: scale(1.1);\n}\n\n/* ==================== DETAIL MEDIA (LEFT SIDE) ==================== */\n\n.lb-detail-media {\n  flex: 1.5;\n  background: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.lb-detail-media-content {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.lb-detail-audio-wrapper {\n  width: 80%;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 12px;\n}\n\n.lb-detail-audio-wrapper audio {\n  width: 100%;\n}\n\n/* ==================== DETAIL SIDEBAR (RIGHT SIDE) ==================== */\n\n.lb-detail-sidebar {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  max-width: 400px;\n}\n\n/* Header */\n.lb-detail-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.lb-detail-user {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.lb-detail-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.lb-detail-user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.lb-detail-username {\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.lb-detail-location {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  color: #666;\n}\n\n.lb-detail-menu {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #333;\n  padding: 0.5rem;\n}\n\n.lb-detail-menu:hover {\n  color: #000;\n}\n\n/* Description */\n.lb-detail-description {\n  padding: 1rem;\n  border-bottom: 1px solid #e0e0e0;\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.lb-detail-desc-username {\n  font-weight: 600;\n  margin-right: 0.5rem;\n}\n\n.lb-detail-desc-text {\n  color: #333;\n}\n\n/* Comments Section */\n.lb-detail-comments {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.lb-detail-comment {\n  display: flex;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.lb-detail-comment-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.lb-detail-comment-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.lb-detail-comment-text {\n  font-size: 0.85rem;\n  line-height: 1.4;\n}\n\n.lb-detail-comment-username {\n  font-weight: 600;\n  margin-right: 0.5rem;\n}\n\n.lb-detail-comment-meta {\n  display: flex;\n  gap: 1rem;\n  font-size: 0.75rem;\n  color: #999;\n}\n\n.lb-detail-comment-meta button {\n  background: none;\n  border: none;\n  color: #999;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.lb-detail-comment-meta button:hover {\n  color: #666;\n}\n\n.lb-detail-comment-like {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #999;\n  padding: 0;\n}\n\n.lb-detail-comment-like:hover {\n  color: #e74c3c;\n}\n\n.lb-detail-no-comments {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 2rem;\n  text-align: center;\n  color: #999;\n}\n\n.lb-detail-no-comments svg {\n  opacity: 0.3;\n}\n\n.lb-detail-no-comments p {\n  font-weight: 600;\n  font-size: 1rem;\n  color: #333;\n  margin: 0;\n}\n\n.lb-detail-no-comments span {\n  font-size: 0.85rem;\n}\n\n/* Footer */\n.lb-detail-footer {\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  border-top: 1px solid #e0e0e0;\n}\n\n.lb-detail-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.lb-detail-actions-left {\n  display: flex;\n  gap: 1rem;\n}\n\n.lb-detail-action-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #333;\n  padding: 0;\n  transition: all 0.2s ease;\n}\n\n.lb-detail-action-btn:hover {\n  color: #000;\n  transform: scale(1.1);\n}\n\n.lb-detail-stats {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.85rem;\n}\n\n.lb-detail-likes {\n  font-weight: 600;\n}\n\n.lb-detail-time {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: #999;\n  font-size: 0.75rem;\n}\n\n.lb-detail-suggests {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  text-align: center;\n}\n\n.lb-detail-comment-form {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 24px;\n}\n\n.lb-detail-comment-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 0.9rem;\n  padding: 0.5rem;\n}\n\n.lb-detail-comment-submit {\n  background: none;\n  border: none;\n  color: #0095f6;\n  cursor: pointer;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.lb-detail-comment-submit:disabled {\n  color: #b3d4ff;\n  cursor: not-allowed;\n}\n\n.lb-detail-comment-submit:not(:disabled):hover {\n  transform: scale(1.1);\n}\n\n/* ==================== RESPONSIVE ==================== */\n\n@media (max-width: 768px) {\n  .lb-detail-modal {\n    flex-direction: column;\n    width: 95vw;\n    height: 90vh;\n  }\n\n  .lb-detail-media {\n    flex: 1;\n    max-height: 50%;\n  }\n\n  .lb-detail-sidebar {\n    flex: 1;\n    max-width: 100%;\n  }\n\n  .lb-container {\n    min-height: 300px;\n    gap: 0.5rem;\n  }\n\n  .lb-grid-2,\n  .lb-grid-3,\n  .lb-grid-4,\n  .lb-grid-6 {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto;\n  }\n\n  .lb-grid-3 .lb-grid-item:first-child,\n  .lb-grid-6 .lb-grid-item:first-child {\n    grid-column: 1;\n    grid-row: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
